import { Button } from '@ps/isp-web-component-library';
import { Link, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import replace from 'lodash/replace';
import trim from 'lodash/trim';
import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router';

import { select } from '@swf/core/store';
import { Message } from '@swf/sports/components';

import {
  TXTWCL_Return_To_N0,
  TXTWCL_This_event_has_now_finishedX
} from './EventFinishedMessage.messages.json';
import styles from './EventFinishedMessage.scss';

const EventFinishedMessage: React.FC = () => {
  const { eventTypeSlug, eventTypeId } = useSelector(select.sports.getUrlParams);

  return (
    <Message message={<Translation {...TXTWCL_This_event_has_now_finishedX} />}>
      <Button
        as={Link}
        alias="sportsAnimalRacingNext"
        values={{
          eventTypeId,
          eventTypeSlug
        }}
        className={classNames(styles.titleCase)}
      >
        <Translation
          values={{ 0: trim(replace(eventTypeSlug, /-/g, ' ')) }}
          {...TXTWCL_Return_To_N0}
        />
      </Button>
    </Message>
  );
};

export default withRouter(EventFinishedMessage);
